import type { BacklogDataValidator as BacklogDataValidatorContract } from "../contracts/api/BacklogDataValidator";
import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import type { BacklogRequestOption } from "../contracts/api/BacklogRequestOption";
import type { BacklogResponse as BacklogResponseContract } from "../contracts/api/BacklogResponse";
import type { BacklogApiSpec } from "../contracts/utils/metadata/BacklogApiSpec";
import { BacklogError } from "../errors/BacklogError";
import type { RequestMethod } from "../types/RequestMethod";
import { assert, resolveBacklogContainer } from "../utils/BacklogUtil";

export class BacklogResponse<T extends object>
	implements BacklogResponseContract<T>
{
	constructor(
		private options: {
			request: {
				url: URL;
				options: BacklogRequestOption;
			};
			response: BacklogHttpResponse;
			data: T;
			spec: {
				endpoint: string;
				method: RequestMethod;
			};
		},
	) {
		assert(options);
		assert(options.request);
		assert(options.response);
		assert(options.spec);
	}

	data(): T {
		return this.options.data;
	}

	getResponse(): BacklogHttpResponse {
		return this.options.response;
	}

	validator(): BacklogDataValidatorContract<T> {
		const spec = this.getSpec();
		return resolveBacklogContainer<T>("BacklogDataValidator", {
			response: this,
			validate: {
				entity_type_key: spec.getEntityTypeKey(),
			},
		});
	}

	getSpec(): BacklogApiSpec<T> {
		const meta = resolveBacklogContainer<T>("BacklogMetadata");
		assert(meta);
		if (this.options.spec.endpoint && this.options.spec.method) {
			const spec = meta.getApiSpec(
				this.options.spec.endpoint,
				this.options.spec.method,
			);
			if (spec) {
				return spec;
			}
		}
		throw new BacklogError("Api Spec Metadata Not Found");
	}
}
